<template>

  <div>
  <el-dialog :title="title" :visible.sync="open" width="850px" append-to-body>

    <section class="header-title" v-show="comesUserOptions.length > 0">个人信息显示</section>

    <el-row  class="form-margin">
      <el-col :span="6" v-for="(item,index) in comesUserOptions" :key="item.id">
        <div class="conditions">
          <el-checkbox  v-model="item.is_show" true-label=1 false-label=2 :checked="item.is_show == 1" :label="item.c_name"></el-checkbox>
        </div>
      </el-col>
    </el-row>

    <section class="header-title"  v-show="comesOtherOptions.length > 0">统计等其他信息展示</section>

    <el-row  class="form-margin">
      <el-col :span="6" v-for="(item,index) in comesOtherOptions" :key="item.id">
        <div class="conditions">
          <el-checkbox  v-model="item.is_show" true-label=1 false-label=2 :checked="item.is_show == 1" :label="item.c_name"></el-checkbox>
        </div>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer" >
      <el-button type="primary" @click="submitForm"size="small">确 定</el-button>
      <el-button @click="cancel" size="small">取 消</el-button>
    </div>

  </el-dialog>
  </div>
</template>

<script>

  import {headerEdit}  from "@/api/tearcher"

 // 表格自定义 头部
  export default {
    name: 'customHeader',

    data() {
      return {
        loading: false,
        title: "", // 弹出层标题
        open: false,  // 是否显示弹出层

        class_id : undefined,

        comesUserOptions: [], //  项目班级报名字段设置表
        comesOtherOptions: [], // 统计等其他信息展示
      }
    },
    mounted() {
      this.class_id = JSON.parse(sessionStorage.getItem("class_id"));
    },

    props: {
      row: {
        type: Object
      }
    },

    computed: {

    },
    methods: {

      handleUpdate() {
        this.open = true;
        this.title = `自定义表头`;

        this.comesUserOptions = this.row.user;
        this.comesOtherOptions =  this.row.other;

      },


      /** 提交按钮 */
      submitForm: function() {

        let postData = [...this.comesUserOptions, ...this.comesOtherOptions]
        headerEdit({'data' : postData}).then(response => {
          if (response.error_code === 201) {
            //this.msgSuccess("设置成功");
            this.$message({
              message: response.msg,
              type: "success",
              duration: messageDuration,
            });
            this.$emit("getList")
            this.cancel();
          }
        }).catch(reason => {
          console.log(reason)
        });
      },
      // 表单重置
      reset() {
        this.comesOtherOptions = [];
        this.comesUserOptions = [];
      },

      // 取消按钮
      cancel() {
        this.open = false;
        this.reset();
      },
    },


    watch: {

    },
  }
</script>

<style lang="less" scoped>
  .header-title {
    font-size: 14px;
    margin-bottom: 10px;
    /* margin-left: 15px; */
    color: #303133;
    background-color: #f2f2f2;
    padding: 10px;
  }

  .conditions {

    margin-bottom: 5px;
  }
</style>
